import sentry from './sentry';
import tagManager from './tag-manager';
import fingerprint from './fingerprint';

export default {
  sentry,
  tagManager,
  fingerprint,
};
